import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import { MapContainer, TileLayer, useMapEvents, ZoomControl } from 'react-leaflet';
import ChangeView from './map_changeView';
import ITSMarkers from './ITS-markers';
import { setMapBounds } from '../../redux/traffic-live';
import 'leaflet/dist/leaflet.css';
import '@bepo65/leaflet.fullscreen/Control.FullScreen.css';

var hanldeMapCenterFormat = function hanldeMapCenterFormat(center) {
  if (_.isEmpty(center)) return {
    lat: 0,
    lng: 0
  };
  var latlngAry = center.split(', ');
  return {
    lat: latlngAry[1],
    lng: latlngAry[0]
  };
};

var ITSMAP = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      _useSelector$envCfg = _useSelector.envCfg,
      gisMapServiceApiUrl = _useSelector$envCfg.gisMapServiceApiUrl,
      gisMapZoomLevelMax = _useSelector$envCfg.gisMapZoomLevelMax,
      gisMapZoomLevelMin = _useSelector$envCfg.gisMapZoomLevelMin,
      gisMapInitViewportCenter = _useSelector$envCfg.gisMapInitViewportCenter,
      gisMapInitViewportZoom = _useSelector$envCfg.gisMapInitViewportZoom,
      _useSelector$trafficL = _useSelector.trafficLive,
      mapMarkerList = _useSelector$trafficL.mapMarkerList,
      filterItems = _useSelector$trafficL.filterItems,
      informationArea = _useSelector$trafficL.informationArea;

  var dispatch = useDispatch();
  var markerTypes = props.markerTypes;

  var _mapRef = useRef();

  var _mounted = useRef(false);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      center = _useState2[0],
      setCenter = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      markers = _useState4[0],
      setMarkers = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      zoom = _useState6[0],
      setZoom = _useState6[1];

  var MapEvent = function MapEvent() {
    var map = useMapEvents({
      zoomlevelschange: function zoomlevelschange(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      },
      moveend: function moveend(e) {
        dispatch(setMapBounds(e.target.getBounds()));
      }
    });
    return null;
  };

  useEffect(function () {
    if (_mounted.current === false) return;

    if (_.isEmpty(informationArea)) {
      setZoom(gisMapInitViewportZoom);
      return setCenter(hanldeMapCenterFormat(gisMapInitViewportCenter));
    }

    setZoom(16);
    var newCenter = {
      lat: informationArea.latitude,
      lng: informationArea.longitude
    };
    setCenter(newCenter);
  }, [JSON.stringify(informationArea)]);
  useEffect(function () {
    if (_mounted.current === false) return;

    var newMarkers = _.map(mapMarkerList, function (mark) {
      if (filterItems.indexOf(mark.dataType) >= 0) return mark;
    });

    setMarkers(_.compact(newMarkers));
  }, [JSON.stringify(filterItems), JSON.stringify(mapMarkerList)]);
  useEffect(function () {
    if (_mounted.current === false) _mounted.current = true;
  }, []);
  if (!gisMapServiceApiUrl) return null;
  return /*#__PURE__*/React.createElement(MapContainer, {
    whenCreated: function whenCreated(mapInstance) {
      _mapRef.current = mapInstance;
      setTimeout(function () {
        mapInstance.invalidateSize();
      }, 250);
    },
    id: "ITS-map",
    center: hanldeMapCenterFormat(gisMapInitViewportCenter),
    zoom: gisMapInitViewportZoom,
    zoomControl: false,
    attributionControl: false
  }, /*#__PURE__*/React.createElement(ChangeView, {
    center: center,
    zoom: zoom
  }), /*#__PURE__*/React.createElement(MapEvent, null), /*#__PURE__*/React.createElement(ZoomControl, {
    position: "bottomright"
  }), /*#__PURE__*/React.createElement(TileLayer, {
    url: gisMapServiceApiUrl,
    maxZoom: gisMapZoomLevelMax,
    minZoom: gisMapZoomLevelMin,
    crossOrigin: true
  }), /*#__PURE__*/React.createElement(ITSMarkers, {
    data: markers,
    markerTypes: JSON.parse(markerTypes)
  }));
});
export default ITSMAP;